// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DownloadingIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DownloadingIcon" ref={forwardedRef} {...props}>
      <path d="M3 3.833h1.5V3H3z" />
      <path d="M15.502 3.833V3h1.5v.833z" />
      <path d="M17.002 7.167V5.5h-1.5v1.667z" />
      <path d="M17.002 8.833V10.5h-1.5V8.833z" />
      <path d="M17.002 15.998v-3.831L17.001 12H15.5v3.497h-11V12H3l.002 3.998C3.002 16.551 3.517 17 4 17h12c.483 0 1.002-.449 1.002-1.002" />
      <path d="M3 10.5V8.833h1.5V10.5z" />
      <path d="M3 5.5v1.667h1.5V5.5z" />
      <path d="M5.757 8.257 10 12.5l4.243-4.243-1.061-1.06-2.432 2.432V3.5h-1.5v6.129L6.818 7.197z" />
    </SvgIcon>
  );
});

/**
 * Use to show the process of downloading
 * @public
 */
export const DownloadingIcon = /* @__PURE__ */ Object.assign(
  DownloadingIconComponent,
  { displayName: 'DownloadingIcon' },
);
